import React, { useEffect, useRef, useState } from 'react';
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';

const PartidoCard = ({ partido, editable, conflicto }) => {
  const ref = useRef(null);
  const [arrastrando, setArrastrando] = useState(false);

  useEffect(() => {
    if (!editable) return;
    const el = ref.current;
    return draggable({
      element: el,
      getInitialData: () => ({ type: 'partido', partidoId: partido.id }),
      onDragStart: () => setArrastrando(true),
      onDrop: () => setArrastrando(false),
    });
  }, [editable, partido.id]);

  const claseConflicto = conflicto ? ' en-conflicto' : '';
  const claseArrastrando = arrastrando ? ' arrastrando' : '';
  const claseEditable = editable ? ' editable' : '';

  return (
    <article
      ref={ref}
      className={`partido-card${claseEditable}${claseArrastrando}${claseConflicto}`}
      title={conflicto ? `Conflicto: ${conflicto.map((c) => c.jugador).join(', ')} también convocado/a en esta franja` : undefined}
    >
      {partido.jornadaOrigen != null && (
        <span className="partido-jornada-banner" title={`Partido de la jornada ${partido.jornadaOrigen} adelantado a esta`}>
          J{partido.jornadaOrigen}
        </span>
      )}
      <span className="partido-modalidad">
        {partido.modalidad}
        {partido.tipo === 'VUELTA' && <span className="partido-tipo"> · vuelta</span>}
      </span>
      <span className="partido-enfrentamiento">
        <span className="partido-lado">
          <span className="partido-equipo">{partido.local}</span>
        </span>
        <span className="partido-vs">vs</span>
        <span className="partido-lado">
          <span className="partido-equipo">{partido.visitante}</span>
        </span>
      </span>
    </article>
  );
};

export default PartidoCard;
